var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nr-count-down-container"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.h))]),_c('span',{staticClass:"colon"},[_vm._v(":")]),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.m))]),_c('span',{staticClass:"colon"},[_vm._v(":")]),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.s))])])
}
var staticRenderFns = []

export { render, staticRenderFns }